import { ConfirmDeleteTransactionComponent
} from './delete-client-transaction/confirm-delete-transaction/confirm-delete-transaction.component';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { Angular2FontAwesomeModule } from 'angular2-font-awesome/angular2-font-awesome';
import { DatepickerModule } from 'angular2-material-datepicker';
import {
    AutoCompleteModule,
    CalendarModule,
    ConfirmDialogModule,
    DataScrollerModule,
    DropdownModule,
    FileUploadModule
} from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { TaskModule } from 'app/task/task.module';

import { TimesheetComponent } from './timesheethandler/timesheet.component';
import { UploadMt940FileComponent } from './uploadmt940file/upload-mt940-file.component';
import { DeleteClientTransactionComponent } from './delete-client-transaction/delete.client.transaction.component';
import { SearchClientPipe } from 'app/shared/pipes/searchClient.pipe';
@NgModule({
    declarations: [
        TimesheetComponent,
        UploadMt940FileComponent,
        DeleteClientTransactionComponent,
        ConfirmDeleteTransactionComponent,
        SearchClientPipe
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        FlexLayoutModule.forRoot(),
        BrowserModule,
        CalendarModule,
        DataScrollerModule,
        DropdownModule,
        FormsModule,
        FileUploadModule,
        AutoCompleteModule,
        ConfirmDialogModule,
        DatepickerModule,
        Angular2FontAwesomeModule,
        TaskModule,
        SharedModule
    ],
    entryComponents: [
        TimesheetComponent,
        UploadMt940FileComponent,
        DeleteClientTransactionComponent,
        ConfirmDeleteTransactionComponent
    ]
})

/**
 * Separate Module for all the components linked with navigation bar.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class NavigationBarModule { }



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/navigation-bar.module.ts